export interface IMediaHelperService {
    isLargeMobile(): boolean;
    isMobile(): boolean;
    isTablet(): boolean;
    isLargeTablet(): boolean;
    isPhone(): boolean;
    isDesktop(): boolean;
}

export class MediaHelper implements IMediaHelperService {
    static serviceId = 'mediaHelperService';
    static $inject = ['$window'];

    constructor(private _$window: angular.IWindowService) {
    }

    isLargeMobile(): boolean {
        return this.isPhone() || this.isLargeTablet();
    }

    isMobile(): boolean {
        return this.isPhone() || this.isTablet();
    }

    isTablet(): boolean {
        return this._$window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches && isTouchEnabled();
    }

    isLargeTablet(): boolean {
        return this._$window.matchMedia('(min-width: 768px) and (max-width: 1200px)').matches;
    }

    isPhone(): boolean {
        return this._$window.matchMedia('(max-width: 767px)').matches && isTouchEnabled();
    }

    isDesktop(): boolean {
        return !this.isPhone() && !this.isTablet();
    }
}


function isTouchEnabled() {
    const nav = (window.navigator as any);
    return ('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (nav.msMaxTouchPoints > 0);
}